const ccmAcls = {
  CCM_ADMIN: 'root.ccm.*',
  CCM_SYSTEM_ADMIN: 'root.admin.*',
  PATIENT_CARD: {
    name: 'root.ccm.patient_card.*',
    read: 'root.ccm.patient_card.read',
    action: 'root.ccm.patient_card.action',
  },
  SEARCH: {
    name: 'root.ccm.searchbar.*',
    SIMPLE_SEARCH: 'root.ccm.searchbar.simplesearch',
    ADVANCED_SEARCH: 'root.ccm.searchbar.advancedsearch',
  },
  TASK_ACTIVITIES: {
    name: 'root.ccm.tasks_activities.*',
    MENU: 'root.ccm.tasks_activities.menu',
    ALL: 'root.ccm.tasks_activities.*',
    ACTIVITIES: {
      name: 'root.ccm.tasks_activities.activities.*',
      READ: 'root.ccm.tasks_activities.activities.read',
      WRITE: 'root.ccm.tasks_activities.activities.write',
    },
    PATIENTS: {
      name: 'root.ccm.tasks_activities.patients.*',
      READ: 'root.ccm.tasks_activities.patients.read',
      WRITE: 'root.ccm.tasks_activities.patients.write',
    },
    REFERRALS: {
      name: 'root.ccm.tasks_activities.referrals.*',
      READ: 'root.ccm.tasks_activities.referrals.read',
      WRITE: 'root.ccm.tasks_activities.referrals.write',
    },
    ALERTS: {
      name: 'root.ccm.tasks_activities.alerts.*',
      READ: 'root.ccm.tasks_activities.alerts.read',
      WRITE: 'root.ccm.tasks_activities.alerts.write',
    },
  },
  CENSUS: {
    name: 'root.ccm.census',
    READ: 'root.ccm.census.read',
  },
  ROUNDINGS: {
    name: 'root.ccm.roundings',
    READ: 'root.ccm.rondings.read',
    WRITE: 'root.ccm.roundings.write',
  },
  GROUP_SESSIONS: {
    name: 'root.ccm.group_sessions',
    READ: 'root.ccm.group_sessions.read',
    WRITE: 'root.ccm.group_sessions.write',
  },
  MED_PASS: {
    name: 'root.ccm.medpass',
    READ: 'root.ccm.medpass.read',
    WRITE: 'root.ccm.medpass.write',
  },
  PATIENt_DEMOGRAPHICS: {
    name: 'root.ccm.demographics',
    READ: 'root.ccm.demographics.read',
  },
  HEALTH_RECORD: {
    name: 'root.ccm.healthrecord',
    READ: 'root.ccm.healthrecord.read',
  },
  CAREPLAN: {
    name: 'root.ccm.careplan',
    write: 'root.ccm.careplan.write',
    read: 'root.ccm.careplan.read',
  },
  REPORTS: {
    name: 'root.ccm.reports',
    READ: 'root.ccm.reports.read',
  },
};

export default ccmAcls;
